// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___W6lwG";
export var text = "styles-module__text___oBAa3";
export var line = "styles-module__line___cLBqR";